export default __webpack_public_path__ + "static/media/DiMaria.dcee78d6.jpg";